import i18next from 'i18next';
import Konva from 'konva';
import { Layer } from 'konva/lib/Layer';
import { Stage } from 'konva/lib/Stage';
import { EDrainageTrenchType, EPosition, EUnitOfMeasure } from '../../shared/enum';
import { redux } from '../../store';
import { EReduxState } from '../../store/enum';
import { ISrcImage } from './Index';
import { drainageTrenchPD } from '../../conversion/drainageTrench';
import { setIndicatorX, setIndicatorY } from './Utils';
import { slopePD } from '../../conversion/slope';
import { drainageChimneyPD } from '../../conversion/drainageChimney';

const campaignPlanLayerHeight = 10;
const impermeableLayerHeight = 15;
const indicatorWidth = 0;
const indicatorHeigth = 30;

const color = {
    initialWaterTableDepth: '#309CAE',
    impermeableLayer: '#D5D3D2',
    water: '#373FCB',
};

export default (type: EDrainageTrenchType, stage: Stage, htmlImgObj: ISrcImage, convertTo: number, onlySlopeAndLoad?: boolean, withExport?: boolean) => {
    const project = redux.getState().project.data!;
    const result = redux.getState().result;

    let wb = project.drainageTrenches![type].wheelbase!;
    if (project.projectInfo.unitOfMeasure == EUnitOfMeasure.Metric) {
        if (wb > 15) wb = 15;
    } else {
        if (wb > 50) wb = 50;
    }

    let initialWaterTableDepth = project.slope!.initialWaterTableDepth! * convertTo;
    let impermeableLayerDepth = project.slope!.impermeableLayerDepth! * convertTo;
    let { soils } = project.soilInputData!;
    let drainPositionDepth = project.drainageTrenches![type].drainPositionDepth! * convertTo;
    let wheelbase = wb * convertTo;
    let drainHeight = project.drainageTrenches![type].product?.productPhysicalDatas![0].drainHeight! * convertTo;
    let drainUnitWidth = project.drainageTrenches![type].product?.productPhysicalDatas![0].drainUnitWidth! * convertTo;
    let waterTableLoweringThickness = project.drainageTrenches![type].waterTableLoweringThickness! * convertTo;
    let diameter = 0;
    if (project.projectInfo.unitOfMeasure == EUnitOfMeasure.Metric) {
        //diameter mm to m
        diameter = (project.drainageTrenches![type].drainPipe?.drainPipeDiameters![0]!.diameter! / 1000) * convertTo;
    } else {
        //diameter inch to foot
        diameter = (project.drainageTrenches![type].drainPipe?.drainPipeDiameters![0]!.diameter! / 12) * convertTo;
    }
    let drainPosition = project.drainageTrenches![type].drainPosition;
    let distributedOverload = project.load?.distributedOverload;
    let numberOfDrains = project.drainageTrenches![type].numberOfDrains!;
    let drainSingle = type == EDrainageTrenchType.PrimaryDrainageTrench && project.drainageTrenches![type].drainSingle!;

    let drainageChimneyHeight = project.drainageTrenches![type].drainageChimney?.drainageChimneyHeight! * convertTo;
    let drainageChimneyWidth = project.drainageTrenches![type].drainageChimney?.drainageChimneyWidth! * convertTo;

    const width = 2 * wheelbase! + 2 * indicatorWidth;
    const height = campaignPlanLayerHeight + impermeableLayerDepth! + impermeableLayerHeight + indicatorHeigth;

    const indicatorY = height - indicatorHeigth / 2;

    const widthEngine = width - 2 * indicatorWidth;
    const heightEngine = height - indicatorHeigth;

    var layer = new Layer();
    var group = new Konva.Group({
        x: (stage.width() - width) / 2,
        y: (stage.height() - height) / 2,
        width,
        height,
        draggable: true,
    });

    if (drainPosition == EPosition.Horizontal) {
        let _height = drainHeight;
        let _width = drainUnitWidth;
        drainHeight = _width;
        drainUnitWidth = _height;
    }

    const createDrain = (x: number, y: number) => [
        new Konva.Rect({
            x,
            y,
            width: drainUnitWidth,
            height: drainHeight,
            fillPatternImage: htmlImgObj!.drainPattern as HTMLImageElement,
            fillPatternScale: {
                x: 0.13,
                y: 0.13,
            },
            stroke: project.drainageTrenches![type].product?.color,
            strokeWidth: 0.7,
        }),
        project.drainageTrenches![type].product?.hasPipe
            ? new Konva.Circle({
                  x: x + drainUnitWidth / 2,
                  y: campaignPlanLayerHeight + drainPositionDepth! - diameter! / 2 - 1,
                  radius: diameter! / 2,
                  fill: 'black',
                  stroke: 'black',
                  strokeWidth: 1,
              })
            : new Konva.Rect({}),
    ];

    const createDrainageChimney = (x: number, y: number) =>
        new Konva.Rect({
            x,
            y,
            width: drainageChimneyWidth,
            height: drainageChimneyHeight,
            fillPatternImage: htmlImgObj.drainPattern as HTMLImageElement,
            fillPatternScale: {
                x: 0.13,
                y: 0.13,
            },
            stroke: project.drainageTrenches![type].product?.color,
            strokeWidth: 0.7,
        });

    var rect = new Konva.Rect({
        x: 0,
        y: 0,
        width,
        height,
        fill: 'transparent',
    });

    var rectEngine = new Konva.Rect({
        x: indicatorWidth,
        y: 0,
        width: widthEngine,
        height: heightEngine,
        fill: withExport ? '#E2F2F4' : 'white',
    });

    var campaignPlanLayer = new Konva.Rect({
        x: indicatorWidth,
        y: 0,
        width: widthEngine,
        height: campaignPlanLayerHeight,
        fill: 'transparent',
    });

    var arrowDistributedOverload = [];
    let numberOfArrow = 15;
    let r = widthEngine / numberOfArrow;
    for (let index = 0; index < numberOfArrow; index++) {
        arrowDistributedOverload.push(
            new Konva.Arrow({
                x: indicatorWidth + r * (index + 1) - r / 2,
                y: 0,
                points: [0, 0, 0, campaignPlanLayerHeight - 2],
                pointerLength: 1,
                pointerWidth: 0.8,
                fill: 'black',
                stroke: 'black',
                strokeWidth: 0.8,
            }),
        );
    }

    let positionLayer = 0;
    var soilLayers = soils!
        .slice()
        .reverse()
        .map(x => {
            positionLayer += x.soilPhysicalData![0].thickness! * convertTo;
            return new Konva.Rect({
                x: indicatorWidth,
                y: campaignPlanLayerHeight + impermeableLayerDepth! - positionLayer,
                width: widthEngine,
                height: x.soilPhysicalData![0].thickness! * convertTo,
                fill: x.color,
                opacity: result.status == EReduxState.fulfilled && !onlySlopeAndLoad ? 0.2 : 1,
            });
        });

    var impermeableLayer = new Konva.Rect({
        x: indicatorWidth,
        y: campaignPlanLayerHeight + impermeableLayerDepth!,
        width: widthEngine,
        height: impermeableLayerHeight,
        fillPatternImage: htmlImgObj.impermeableLayerPattern as HTMLImageElement,
        fillPatternScale: {
            x: 0.5,
            y: 0.5,
        },
        opacity: result.status == EReduxState.fulfilled && !onlySlopeAndLoad ? 0.4 : 1,
    });

    var drain = [];
    let startDrainX = indicatorWidth + (!drainSingle ? wheelbase! / 2 : wheelbase!);
    switch (numberOfDrains) {
        case 1:
            startDrainX = startDrainX - drainUnitWidth! / 2;
            break;
        case 2:
            startDrainX = startDrainX - drainUnitWidth!;
            break;
        case 3:
            startDrainX = startDrainX - (3 * drainUnitWidth!) / 2;
            break;
        default:
            break;
    }

    for (let index = 0; index < numberOfDrains; index++) {
        drain.push(
            ...createDrain(startDrainX + drainUnitWidth * index, campaignPlanLayerHeight + drainPositionDepth! - drainHeight!),
            ...(!drainSingle ? createDrain(startDrainX + drainUnitWidth * index + wheelbase, campaignPlanLayerHeight + drainPositionDepth! - drainHeight!) : [new Konva.Rect({})]),
        );
    }

    var drainageChimney = [];
    let startDrainageChimneyX = indicatorWidth + (!drainSingle ? wheelbase! / 2 : wheelbase) - drainageChimneyWidth! / 2;
    if (project.drainageTrenches![type].hasDrainageChimney) {
        drainageChimney.push(
            createDrainageChimney(startDrainageChimneyX, campaignPlanLayerHeight + drainPositionDepth! - drainHeight! - drainageChimneyHeight),
            !drainSingle ? createDrainageChimney(startDrainageChimneyX + wheelbase, campaignPlanLayerHeight + drainPositionDepth! - drainHeight! - drainageChimneyHeight) : new Konva.Rect({}),
        );
    }

    var groundwaterWithDrain = new Konva.Shape({
        fillPatternImage: htmlImgObj.waterPattern as HTMLImageElement,
        fillPatternScale: {
            x: 0.3,
            y: 0.3,
        },
        opacity: result.status == EReduxState.fulfilled && !onlySlopeAndLoad ? 0.5 : 1,
        sceneFunc: function (context, shape) {
            context.beginPath();
            context.ellipse(indicatorWidth, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, (3 * Math.PI) / 2, 2 * Math.PI);
            if (!drainSingle) context.ellipse(indicatorWidth + wheelbase, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, Math.PI, 2 * Math.PI);
            context.ellipse(indicatorWidth + 2 * wheelbase, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, Math.PI, (3 * Math.PI) / 2);
            context.lineTo(indicatorWidth + 2 * wheelbase, campaignPlanLayerHeight + impermeableLayerDepth!);
            context.lineTo(indicatorWidth, campaignPlanLayerHeight + impermeableLayerDepth!);
            context.closePath();
            context.fillStrokeShape(shape);
        },
    });

    var referenceWaterLine = new Konva.Shape({
        opacity: result.status == EReduxState.fulfilled && !onlySlopeAndLoad ? 0.5 : 1,
        stroke: color.water,
        strokeWidth: 1,
        sceneFunc: function (context, shape) {
            context.beginPath();
            context.ellipse(indicatorWidth, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, (3 * Math.PI) / 2, 2 * Math.PI);
            context.strokeShape(shape);

            if (!drainSingle) {
                context.beginPath();
                context.ellipse(indicatorWidth + wheelbase, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, Math.PI, 2 * Math.PI);
                context.strokeShape(shape);
            }

            context.beginPath();
            context.ellipse(indicatorWidth + 2 * wheelbase, campaignPlanLayerHeight + drainPositionDepth!, startDrainX, waterTableLoweringThickness!, 0, Math.PI, (3 * Math.PI) / 2);
            context.strokeShape(shape);
        },
    });

    var groundwaterWithoutDrain = new Konva.Shape({
        fillPatternImage: htmlImgObj.waterPattern as HTMLImageElement,
        fillPatternScale: {
            x: 0.3,
            y: 0.3,
        },
        sceneFunc: function (context, shape) {
            context.beginPath();
            context.moveTo(indicatorWidth, campaignPlanLayerHeight + initialWaterTableDepth);
            context.lineTo(indicatorWidth + widthEngine, campaignPlanLayerHeight + initialWaterTableDepth!);
            context.lineTo(indicatorWidth + widthEngine, campaignPlanLayerHeight + impermeableLayerDepth!);
            context.lineTo(indicatorWidth, campaignPlanLayerHeight + impermeableLayerDepth!);
            context.closePath();
            context.fillStrokeShape(shape);
        },
    });

    var referenceCampaignPlanLine = new Konva.Line({
        points: [indicatorWidth, campaignPlanLayerHeight, indicatorWidth + widthEngine, campaignPlanLayerHeight],
        stroke: 'black',
        strokeWidth: 0.3,
        lineJoin: 'round',
    });

    var referenceInitialWaterTableDepth = new Konva.Line({
        points: [indicatorWidth, campaignPlanLayerHeight + initialWaterTableDepth!, indicatorWidth + widthEngine, campaignPlanLayerHeight + initialWaterTableDepth!],
        stroke: color.initialWaterTableDepth,
        strokeWidth: 1,
        lineJoin: 'round',
        dash: [3, 3],
    });

    var referenceDrainBaseLine = new Konva.Line({
        points: [indicatorWidth, campaignPlanLayerHeight + drainPositionDepth!, indicatorWidth + widthEngine, campaignPlanLayerHeight + drainPositionDepth!],
        stroke: 'black',
        strokeWidth: 1,
        lineJoin: 'round',
        dash: [3, 3],
    });

    let startWheelbaseIndicatorX = indicatorWidth + (!drainSingle ? wheelbase! / 2 : 0);
    var wheelbaseIndicator = [
        ...setIndicatorX(startWheelbaseIndicatorX, indicatorY, !drainSingle ? wheelbase : 2 * wheelbase),
        new Konva.Text({
            x: indicatorWidth + wheelbase! - 22,
            y: indicatorY - 8,
            text: !drainSingle
                ? i18next.t('distanceBetweenDrains', {
                      value: project.drainageTrenches![type].wheelbase! + ' ' + drainageTrenchPD['wheelbase'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
                  })
                : i18next.t('slopeWidthIndicator', {
                      value: project.slope?.slopeWidth! + ' ' + slopePD['slopeWidth'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
                  }),
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    var impermeableLayerDepthIndicator = [
        ...setIndicatorY(indicatorWidth + wheelbase! / 8, campaignPlanLayerHeight, impermeableLayerDepth),
        new Konva.Text({
            x: indicatorWidth + wheelbase! / 8 + 2,
            y: campaignPlanLayerHeight + impermeableLayerDepth / 2,
            text: project.slope?.impermeableLayerDepth! + ' ' + slopePD['impermeableLayerDepth'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    var drainPositionDepthIndicator = [
        ...setIndicatorY(indicatorWidth + wheelbase! / 4, campaignPlanLayerHeight, drainPositionDepth),
        new Konva.Text({
            x: indicatorWidth + wheelbase! / 4 + 2,
            y: campaignPlanLayerHeight + drainPositionDepth / 2,
            text: project.drainageTrenches![type].drainPositionDepth! + ' ' + drainageTrenchPD['drainPositionDepth'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    let startDrainHeightIndicatorX = startDrainX + (!drainSingle ? wheelbase : 0);
    var drainHeightIndicator = [
        ...setIndicatorY(startDrainHeightIndicatorX + drainUnitWidth * numberOfDrains + 5, campaignPlanLayerHeight + drainPositionDepth - drainHeight, drainHeight),
        new Konva.Text({
            x: startDrainHeightIndicatorX + drainUnitWidth * numberOfDrains + 5 + 2,
            y: campaignPlanLayerHeight + drainPositionDepth - drainHeight / 2 - 3,
            text: drainHeight / convertTo + ' ' + drainageTrenchPD['drainHeight'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    let startDrainageChimneyHeightIndicatorX = startDrainX + (!drainSingle ? wheelbase : 0);
    var drainageChimneyHeightIndicator = project.drainageTrenches![type].hasDrainageChimney
        ? [
              ...setIndicatorY(
                  startDrainageChimneyHeightIndicatorX + drainUnitWidth * numberOfDrains + 5,
                  campaignPlanLayerHeight + drainPositionDepth! - drainHeight! - drainageChimneyHeight,
                  drainageChimneyHeight,
              ),
              new Konva.Text({
                  x: startDrainageChimneyHeightIndicatorX + drainUnitWidth * numberOfDrains + 5 + 2,
                  y: campaignPlanLayerHeight + drainPositionDepth! - drainHeight! - drainageChimneyHeight / 2,
                  text: project.drainageTrenches![type].drainageChimney?.drainageChimneyHeight! + ' ' + drainageChimneyPD['drainageChimneyHeight'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
                  fontSize: 6,
                  fontFamily: 'Calibri',
                  fill: 'black',
                  fontStyle: 'bold',
              }),
          ]
        : [new Konva.Line({})];

    let startWaterTableLoweringThicknessIndicatorX = indicatorWidth + (!drainSingle ? wheelbase : wheelbase / 2);
    var waterTableLoweringThicknessIndicator = [
        ...setIndicatorY(startWaterTableLoweringThicknessIndicatorX, campaignPlanLayerHeight + drainPositionDepth - waterTableLoweringThickness, waterTableLoweringThickness),
        new Konva.Text({
            x: startWaterTableLoweringThicknessIndicatorX - 4,
            y: campaignPlanLayerHeight + drainPositionDepth - waterTableLoweringThickness - 9,
            text: project.drainageTrenches![type].waterTableLoweringThickness! + ' ' + drainageTrenchPD['waterTableLoweringThickness'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    let startDrainUnitWidthIndicatorX = indicatorWidth + (!drainSingle ? (3 * wheelbase) / 2 : wheelbase);
    var drainUnitWidthIndicator = [
        ...setIndicatorX(startDrainUnitWidthIndicatorX - drainUnitWidth / 2, campaignPlanLayerHeight + drainPositionDepth + 4, drainUnitWidth),
        new Konva.Text({
            x: startDrainUnitWidthIndicatorX,
            y: campaignPlanLayerHeight + drainPositionDepth + 6,
            text: drainUnitWidth / convertTo + ' ' + drainageTrenchPD['drainUnitWidth'].unitOfMeasure[project.projectInfo.unitOfMeasure!],
            fontSize: 6,
            fontFamily: 'Calibri',
            fill: 'black',
            fontStyle: 'bold',
        }),
    ];

    var campaignPlanText = new Konva.Text({
        x: indicatorWidth,
        y: -6,
        text: i18next.t('campaignPlan'),
        fontSize: 6,
        fontFamily: 'Calibri',
        fill: 'black',
        fontStyle: 'bold',
    });

    var impermeableLayerText = new Konva.Text({
        x: indicatorWidth + widthEngine - 60,
        y: heightEngine - 8,
        text: i18next.t('waterproofLayer'),
        fontSize: 6,
        fontFamily: 'Calibri',
        fill: 'black',
        fontStyle: 'bold',
    });

    var backgroundImpermeableLayerText = new Konva.Rect({
        x: impermeableLayerText.x(),
        y: impermeableLayerText.y(),
        width: impermeableLayerText.width() + 3.5,
        height: impermeableLayerText.height(),
        fill: 'white',
    });

    if (onlySlopeAndLoad) {
        group.add(
            rect,
            rectEngine,
            campaignPlanLayer,
            impermeableLayer,
            ...soilLayers,
            groundwaterWithoutDrain,
            referenceCampaignPlanLine,
            referenceInitialWaterTableDepth,
            ...impermeableLayerDepthIndicator,
            campaignPlanText,
            backgroundImpermeableLayerText,
            impermeableLayerText,
        );
    } else {
        group.add(
            rect,
            rectEngine,
            campaignPlanLayer,
            impermeableLayer,
            ...soilLayers,
            result.status == EReduxState.fulfilled ? groundwaterWithDrain : new Konva.Rect(),
            ...drain,
            ...drainageChimney,
            referenceCampaignPlanLine,
            referenceInitialWaterTableDepth,
            result.status == EReduxState.fulfilled ? referenceWaterLine : new Konva.Line(),
            referenceDrainBaseLine,
            ...wheelbaseIndicator,
            ...impermeableLayerDepthIndicator,
            ...drainPositionDepthIndicator,
            ...drainHeightIndicator,
            ...drainageChimneyHeightIndicator,
            ...drainUnitWidthIndicator,
            ...(result.status == EReduxState.fulfilled ? waterTableLoweringThicknessIndicator : [new Konva.Line({})]),
            campaignPlanText,
            backgroundImpermeableLayerText,
            impermeableLayerText,
        );
    }

    if (distributedOverload! > 0) {
        group.add(...arrowDistributedOverload);
    }

    layer.add(group);

    return { width, height, layer };
};
